import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ContactStyle } from '../globe/contactShape';

export const usePresentation = create<{
  contactStyle: ContactStyle;
  eventFollowing: boolean;
  setContactStyle: (style: ContactStyle) => void;
  setEventFollowing: (enabled: boolean) => void;
}>()(
  persist(
    (set) => ({
      contactStyle: 'line-of-sight',
      eventFollowing: false,
      setContactStyle: (contactStyle) => set({ contactStyle }),
      setEventFollowing: (eventFollowing) => set({ eventFollowing }),
    }),
    {
      name: 'gemdt-presentation',
      version: 2,
      // Drop the retired GEO filter, retaining the user's v1 line-style choice.
      // Pre-v1 preferences still receive the straight-line default.
      migrate: (persisted, version): { contactStyle: ContactStyle } => ({
        contactStyle:
          version >= 1 && (persisted as { contactStyle?: unknown } | null)?.contactStyle === 'schematic'
            ? 'schematic'
            : 'line-of-sight',
      }),
      partialize: (s) => ({ contactStyle: s.contactStyle }),
    },
  ),
);
